// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBHAg2z5NXslHPPEq8grsJ3klA5kQh0vI0",
    authDomain: "facebook-clone-2428e.firebaseapp.com",
    databaseURL: "https://facebook-clone-2428e.firebaseio.com",
    projectId: "facebook-clone-2428e",
    storageBucket: "facebook-clone-2428e.appspot.com",
    messagingSenderId: "222604002550",
    appId: "1:222604002550:web:3aac70783539b20e0ed8d7",
    measurementId: "G-ZMH77R0KB8"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebaseApp.storage()
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, storage };
export default db;